/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 6/25/14
 * Time: 12:03 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");
    var AbstractAppender = require("notificationCenter/appenders/AbstractAppender");

    var PersonaNotification = AbstractAppender.extend({

        defaultOptions: {
            toolTip:""
        },

        initialize: function (options) {
            AbstractAppender.prototype.initialize.call(this, options);

            if(!this.isSupported()) {
                return;
            }
        },
        isEnabled: function () {
            return true;
        },
        isSupported: function () {
            return true;
        },
        getDefaultOptions: function () {
            return _.cloneDeep(this.defaultOptions);
        },
        notify: function (options) {
            if (!options.num || isNaN(options.num) || Number(options.num) === 0) {
                this.clearNotifications(options);
            }
            else {
               this.App.vent.trigger("onPersonaNotification:notification", {persona: options.persona,
                   notifications: options.num,
                   notificationType: "chat",
                   notificationsTooltip: options.toolTip
               });
            }
        },
        clearNotifications: function (options) {
            this.App.vent.trigger("onPersonaNotification:notification", {persona: options.persona,
                notifications: 0,
                notificationType: "chat",
                notificationsTooltip: ""
            });
        },
        isValidOptions: function (options) {
            var isValid = AbstractAppender.prototype.isValidOptions.call(this, options);
            if (isValid) {
                if (!options.persona) {
                    isValid = false;
                    this.logger.error("DesktopNotification: options.persona is invalid or missing");
                    this.logger.graph({name:"framework:personaNotification:isValidOptions:personaInvalid"});
                }
            }
            return isValid;
        },
        clearNotification:function(options){
        }
    });

    PersonaNotification.options = [
        "num",
        "toolTip",
        "persona"
    ];

    return PersonaNotification;

});

